export default {
  set_men_id: (state, data) => state.menuId = data,
  set_men_name: (state, data) => state.menuNameSp = data,
  set_men_order: (state, data) => state.menuOrder = data,
  set_men_name_en: (state, data) => state.menuNameEn = data,
  set_men_name_pr: (state, data) => state.menuNamePr = data,
  set_men_route: (state, data) => state.menuRoute = data,
  set_men_param: (state, data) => state.menuParam = data,
  set_men_icon: (state, data) => state.menuIcon = data,
  set_men_isadmin: (state, data) => state.menuIsAdmin = data,
  set_men_parent: (state, data) => state.menuParent = data,
  set_men_status: (state, data) => state.menuStatus = data,
  trash_menu(state) {
    state.menuId = 0;
    state.menuOrder = '';
    state.menuNameSp = '';
    state.menuNameEn = '';
    state.menuNamePr = '';
    state.menuRoute = '';
    state.menuParam = '';
    state.menuIcon = '';
    state.menuIsAdmin = '';
    state.menuParent = 0;
    state.menuStatus = '';
  }
}
